export enum FeatureFlag {
  BILLING_USAGE_REVAMP = 'billing-usage-revamp',
  CLOUD_COMPASS_CREDENTIAL = 'cloud-compass-credential',
  CLOUD_COMPASS_RENEWAL = 'cloud-compass-renewal',
  PROJECT_SIDEBAR_TREE = 'project-sidebar-tree',
  CLOUD_COMPASS_INSIGHTS = 'cloud-compass-insights',
  ENVIRONMENT_OUTPUT_SCOPED_FETCH = 'environment-output-scoped-fetch',
  CLOUD_COMPASS_GRAPH = 'cloud-compass-graph',
  CLOUD_COMPASS_COST = 'cloud-compass-cost',
  REPOSITORY_CUSTOM_FLOWS_RBAC = 'repository-custom-flows-rbac',
  STEPPED_ONBOARDING = 'stepped-onboarding'
}

export const localFeatureFlagValues = {
  [FeatureFlag.BILLING_USAGE_REVAMP]: false,
  [FeatureFlag.CLOUD_COMPASS_CREDENTIAL]: false,
  [FeatureFlag.CLOUD_COMPASS_RENEWAL]: false,
  [FeatureFlag.PROJECT_SIDEBAR_TREE]: false,
  [FeatureFlag.CLOUD_COMPASS_INSIGHTS]: false,
  [FeatureFlag.ENVIRONMENT_OUTPUT_SCOPED_FETCH]: false,
  [FeatureFlag.CLOUD_COMPASS_GRAPH]: false,
  [FeatureFlag.CLOUD_COMPASS_COST]: false,
  [FeatureFlag.REPOSITORY_CUSTOM_FLOWS_RBAC]: false,
  [FeatureFlag.STEPPED_ONBOARDING]: false
};

export type FeatureFlags = typeof localFeatureFlagValues;

export const FEATURE_FLAG_OVERRIDES_STORAGE_KEY = 'ENV0_FEATURE_FLAG_OVERRIDES';

export const readFeatureFlagOverrides = (): Partial<FeatureFlags> => {
  try {
    const stored = localStorage.getItem(FEATURE_FLAG_OVERRIDES_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};
